const steps = [
  {
    key: "company",
    label: "🎯 Target Company",
    options: [
      "Google",
      "Microsoft",
      "Amazon",
      "Meta",
      "Apple",
      "Netflix",
      "Adobe",
      "Flipkart",
      "Uber",
      "TCS",
      "Other",
    ],
  },
  {
    key: "role",
    label: "💼 Target Role",
    options: [
      "Frontend Developer",
      "Backend Developer",
      "Full Stack Developer",
      "Other",
    ],
  },
  {
    key: "experience",
    label: "🧠 Coding Experience",
    options: ["Basic", "Intermediate", "Advanced", "Other"],
  },
  {
    key: "codingTime",
    label: "⏳ Years of Coding",
    options: ["1", "2", "3", "4", "5", "6+", "Other"],
  },
  {
    key: "background",
    label: "🏫 Background",
    options: ["IT", "Non-IT"],
  },
  {
    key: "education",
    label: "🎓 Education",
    options: ["B.Tech", "M.Tech", "BCA", "MCA", "BSc", "MSc", "Other"],
  },
  {
    key: "language",
    label: "💻 Preferred Language",
    options: ["JavaScript", "Python", "Java", "C++", "C", "Other"],
  },
];

export default steps;